module.exports = __webpack_public_path__ + "img/3.4055e2d5.png";